<template>
  <b-modal
    :visible="value"
    title="Add New Client"
    size="lg"
    no-close-on-backdrop
    @change="$emit('input', $event)"
    @hidden="resetForm"
  >
    <p class="text-muted small mb-3">
      Creates a client record for invoicing. Once the backend ships
      <code>POST /invoice/config/clients</code>, all fields below will persist to the master-data table.
    </p>
    <b-row>
      <b-col md="6">
        <b-form-group label="Client Name *" label-for="new-client-name">
          <b-form-input
            id="new-client-name"
            v-model="form.clientName"
            placeholder="e.g. GPS Renewables"
            trim
            :state="errors.clientName ? false : null"
          />
          <b-form-invalid-feedback>{{ errors.clientName }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Legal Name" label-for="new-legal-name">
          <b-form-input id="new-legal-name" v-model="form.legalName" placeholder="Legal entity name on invoice" trim />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="GST Number" label-for="new-gst">
          <b-form-input id="new-gst" v-model="form.clientGST" placeholder="GSTIN" trim />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="State *" label-for="new-state">
          <b-form-input
            id="new-state"
            v-model="form.clientState"
            placeholder="e.g. Maharashtra"
            trim
            :state="errors.clientState ? false : null"
          />
          <b-form-invalid-feedback>{{ errors.clientState }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Address" label-for="new-address">
          <b-form-textarea id="new-address" v-model="form.clientAddress" rows="2" placeholder="Registered / billing address" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Place of Supply" label-for="new-pos">
          <b-form-input id="new-pos" v-model="form.placeOfSupply" placeholder="City or location for GST" trim />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Contact" label-for="new-contact">
          <b-form-input id="new-contact" v-model="form.clientPhone" placeholder="Phone / email" trim />
        </b-form-group>
      </b-col>
    </b-row>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="$emit('input', false)">Cancel</b-button>
      <b-button variant="primary" :disabled="saving" @click="submit">
        <b-spinner v-if="saving" small class="mr-1" />Save Client
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BFormInput, BFormTextarea,
  BButton, BSpinner, BFormInvalidFeedback,
} from 'bootstrap-vue'

const EMPTY = () => ({
  clientName: '',
  legalName: '',
  clientGST: '',
  clientAddress: '',
  clientState: '',
  placeOfSupply: '',
  clientPhone: '',
})

export default {
  name: 'AddClientModal',
  components: {
    BModal, BRow, BCol, BFormGroup, BFormInput, BFormTextarea,
    BButton, BSpinner, BFormInvalidFeedback,
  },
  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      form: EMPTY(),
      errors: {},
    }
  },
  methods: {
    resetForm() {
      this.form = EMPTY()
      this.errors = {}
    },
    validate() {
      const errors = {}
      if (!this.form.clientName || !this.form.clientName.trim()) {
        errors.clientName = 'Client name is required'
      }
      if (!this.form.clientState || !this.form.clientState.trim()) {
        errors.clientState = 'State is required'
      }
      this.errors = errors
      return Object.keys(errors).length === 0
    },
    submit() {
      if (!this.validate()) return
      this.$emit('submit', { ...this.form })
    },
  },
}
</script>
